import React from 'react';
import Form from '../../../../../../../../components/Form/Form/';
import IndustrySelector from '../IndustrySelector/';
import Spinner from '../../../../../../../../components/Spinner/';
import ExperienceInput from '../ExperienceInput';

import './Experience.scss';

export default class ProfileExperience extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      changeMade: false,
      saving: false,
      errorFound: null,
      customButtonMessage: null,
      errorIndex: null,
      currentValues: {
        Experience: null,
        Industries: null,
      },
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.getButtonText = this.getButtonText.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
  }

  componentDidMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  };

  routerWillLeave(nextLocation) {
    if (this.state.changeMade) {
      return 'Your work is not saved! Are you sure you want to leave?';
    }
  };

  handleChange(event) {
    window.onbeforeunload = function () {
      return true;
    };

    this.setState({
      changeMade: true,
      currentValues: event.target.value,
      customButtonMessage: null,
      errorFound: null,
    });
  }

  handleSave() {
    this.setState({
      saving: true,
      errorIndex: null,
    });
    let errorIndex = null;

    if (errorIndex === null) {
      Bugsnag.leaveBreadcrumb('Attempting to Upsert the positions');

      new Promise(resolve => {
        console.log(this.state.currentValues.Experience, this.state.currentValues);
        if (typeof this.state.currentValues.Experience !== 'undefined' && this.state.currentValues.Experience !== null) { // Are changes made
          this.props.SetPositions({
            variables: {
              Experience: this.state.currentValues.Experience,
            },
          }).then(() => resolve());
        } else {
          resolve({}); // No Changes made dont update server
        }
      }).then(() => {
        if (typeof this.state.currentValues.Industries !== 'undefined' && this.state.currentValues.Industries !== null) {
          if (this.state.currentValues.Industries.length > 0) {
            return this.props.UpsertIndustry({
              variables: {
                IndustryInputs: this.state.currentValues.Industries.map(ID => ({
                  industry_id: ID,
                  type: 'expertise',
                })),
              }
            });
          }
        }
        return Promise.resolve(false);
      }).then(data => {
        Bugsnag.leaveBreadcrumb('Succesfully upserted: ' + JSON.stringify(data, null, 2));
        window.onbeforeunload = null;
        this.setState({
          saving: false,
          changeMade: false,
          customButtonMessage: 'Saved Successfully',
        });
      }).catch(error => {
        Bugsnag.notifyException(error);
        console.log(error);
        this.setState({
          saving: false,
          changeMade: true,
          errorFound: true,
          customButtonMessage: 'An error occured. Please try again in a moment or try logging out then back in',
        });
      });
    } else {
      this.setState({
        saving: false,
        changeMade: true,
        errorFound: true,
        customButtonMessage: 'Form incomplete. Please fill out all required fields.',
      });
    }
  }

  getButtonText() {
    if (this.state.customButtonMessage !== null) {
      return this.state.customButtonMessage;
    }

    if (this.state.saving) {
      return <Spinner className="spinner--white" />;
    }

    if (this.state.changeMade === false) {
      return 'No Changes made';
    }

    return 'Save';
  }

  getError() {
    if (this.state.errorIndex !== null) {
      const CompanyData = this.state.currentValues.Company[this.state.errorIndex];

      if (typeof CompanyData['Company'] === 'undefined') {
        if (Object.prototype.hasOwnProperty.call(CompanyData, 'JobTitle') === false && CompanyData['JobTitle'] !== '') {
          return (
            <p className="error-text">{'Entry ' + (this.state.errorIndex + 1) + ' is missing a Job title and Company'}</p>
          );
        }
        return (
          <p className="error-text">{'Entry ' + (this.state.errorIndex + 1) + ' is missing a Company'}</p>
        );
      }

      if (Object.prototype.hasOwnProperty.call(CompanyData, 'JobTitle') === false && CompanyData['JobTitle'] !== '') {
        return (
          <p className="error-text">{'Entry ' + (this.state.errorIndex + 1) + ' is missing a Job title'}</p>
        );
      }

      return null;
    }
  }

  render() {
    console.log(this.props.ExperienceData);
    const { ExperienceData } = this.props;
    return (
      <div>
        <div className="ProfileExperience">
          <Form onChange={this.handleChange}>
            <h1>Profile Experience</h1>
            {this.getError()}
            <ExperienceInput name="Experience" InitialData={ExperienceData.viewer ? ExperienceData.viewer.job_positions : null} />
            <br />
            <br />
            <h1>Industries</h1>
            <small>What industries are you most familiar with?</small>
            <IndustrySelector name="Industries"
              defaultValue={ExperienceData.viewer ? ExperienceData.viewer.industries.map(Industry => Industry.industry_id) : null}
              Industries={ExperienceData.getIndustryCategories} />
          </Form>
        </div>
        <button disabled={this.state.changeMade === false && this.state.saving === false} onClick={this.handleSave}
          style={(this.state.errorFound === null) ? {} : { background: '#e85959' }} className="Experience__SaveButton">
          {this.getButtonText()}
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/Experience/components/Experience/index.js